import { SidebarModule } from '../constants/Enums';
import { PconLoginStore } from '../stores/PconLoginStore';

declare var ga: any;

type StatsEventCategory = 'Catalog' | 'Manufacturer Catalog' |
    'Article' | 'Article List' | 'Send' | 'Interaction' | 'Download' |
    'Help' | 'News' | 'Projects' | 'Orientation' | 'Appstore' | 'pCon.login' |
    'FloorPlan';

export type StatsEventAction = 'app' | 'change' | 'click link' |
    'configure' | 'create' | 'delete' | 'download' | 'duplicate' | 'e-mail' |
    'finished' | 'floorplan' | 'initial' | 'insert' | 'multi select' | 'open' |
    'rectangular select' | 'redo' | 'save' | 'search' | 'setup' | 'settingchange' |
    'share' | 'show' | 'undo' | 'views' | 'visibilitychange';

type StatsEventPage = 'into' | 'pCon.login' | 'projects' | 'news' |
    'help' | 'settings' | 'properties' | 'article list' | 'share' |'catalog' |
    'planning' | 'inspirations' | 'floorplan';

interface StatsEvent {
    category: StatsEventCategory;
    action: StatsEventAction;
    label?: string | null;
    value?: number;
}

export abstract class Stats {
    public static readonly enabled: boolean = ((): boolean => {
        const enabled: boolean = typeof ga !== 'undefined';

        // init stuff
        if (enabled) {
            window.addEventListener('orientationchange', () => {
                Stats.updateOrientation();
            });
        }

        return enabled;
    })();
    private static lastPagePath: string | null = null;

    public static sendEvent(data: StatsEvent): void {
        if (data != null && Stats.enabled) {
            try {
                ga('send', 'event', data.category, data.action, data.label, data.value);
            } catch (error) {
                console.error(error);
            }
        }
    }

    public static sendPageView(page: StatsEventPage, subPages: Array<string> = []): void {
        if (Stats.enabled) {
            try {
                const path: string = ['', page as string].concat(subPages).join('/');

                if (path === Stats.lastPagePath) {
                    return;
                }
                Stats.lastPagePath = path;

                ga('set', 'page', path);
                ga('send', 'pageview');
            } catch (error) {
                console.error(error);
            }
        }
    }

    public static updateOrientation(): void {
        if (Stats.enabled) {
            try {
                const orientation: string = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
                ga('set', 'dimension2', orientation);
            } catch (error) {
                console.error(error);
            }
        }
    }

    public static updateLoginState(): void {
        if (Stats.enabled) {
            try {
                let state: 'WithoutLogin' | 'LoginWithData' | 'LoginWithoutData';
                if (PconLoginStore.getUserId() != null) {
                    state = PconLoginStore.hasPackageGroups() ? 'LoginWithData' : 'LoginWithoutData';
                } else {
                    state = 'WithoutLogin';
                }

                ga('set', 'dimension3', state);
            } catch (error) {
                console.error(error);
            }
        }
    }

    public static sendSidebar(sidebar: SidebarModule): void {
        switch (sidebar) {
            case SidebarModule.NONE:
                Stats.sendPageView('planning');
                break;
            case SidebarModule.CATALOG:
                Stats.sendPageView('catalog');
                break;
            case SidebarModule.ARTICLELIST:
                Stats.sendPageView('article list');
                break;
            case SidebarModule.PROPERTIES:
                Stats.sendPageView('properties');
                break;
            case SidebarModule.INSPIRATIONS:
                Stats.sendPageView('inspirations');
                break;
            case SidebarModule.SHARE:
                Stats.sendPageView('share');
                break;
            case SidebarModule.SHARE_MAIL:
                Stats.sendPageView('share', ['mail']);
                break;
            case SidebarModule.SHARE_APP:
                Stats.sendPageView('share', ['app']);
                break;
            default:
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/Stats.ts